export const getCardImage = ({
  slug = null,
  heroImage = null,
  heroVideo = null,
  image = null,
  width = null,
  height = null,
  contentType = null,
  cardConfigurations = null,
  type = null,
  context = null,
  clientContext = null,
}) => {
  let { isMobile, isAmp } = clientContext;
  let { settings } = context.data;

  let cardImage = {
    image: null,
    url: null,
    title: null,
    analytics: null,
    showPlayIcon: null,
    path: null,
  };

  // If an override width or height is set, use it, otherwise get the default for this type of card.
  let configurationWidth =
    width !== undefined && width !== null
      ? width
      : cardConfigurations.image[contentType][isMobile ? "mobile" : "desktop"][
          type
        ].widthValue;
  let configurationHeight =
    height !== undefined && height !== null
      ? height
      : cardConfigurations.image[contentType][isMobile ? "mobile" : "desktop"][
          type
        ].heightValue;

  if (contentType === "article") {
    cardImage = {
      image: heroImage.fields.image,
      width: configurationWidth,
      height: configurationHeight,
    };
  } else if (contentType === "list") {
    cardImage = {
      image: image,
      width: configurationWidth,
      height: configurationHeight,
    };
  }

  try {
    if (
      cardImage !== undefined &&
      cardImage !== null &&
      cardImage.image !== undefined &&
      cardImage.image !== null
    ) {
      let image = cardImage.image;

      cardImage.url = image.fields.file.url;
      cardImage.title = image.fields.title; // @TODO Alt caption, could be better?

      cardImage.scaledHeight =
        (image.fields.file.details.image.height * cardImage.width) /
        image.fields.file.details.image.width;
    }

    if (heroVideo && heroVideo.fields.videoUrl) {
      cardImage.showPlayIcon = true;
    }
  } catch (error) {
    console.error("image error", error);
  }

  return cardImage;
};
